<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->


document.addEventListener('DOMContentLoaded', () => {
    // Check if we are on the homepage
    if (window.location.pathname === "/") {
        const menuContainer = document.querySelector('.ib-container');
        const hamburger = document.querySelector('.header-nav-hamburger');
        const logoTransparent = document.querySelector('.header__heading-logo.logo--transparent');
        const logoMain = document.querySelector('.logo__main');
        const stickyHeader = document.querySelector('.header-navigation-wrapper');

        // Function to toggle logo based on scroll position and data-sticky-type
        const toggleLogoOnScroll = () => {
            // Show main logo only if scrolled past a certain point (e.g., 100px)
            if (window.scrollY > 100 && stickyHeader.getAttribute('data-sticky-type') === 'on_scroll') {
                logoMain.style.display = 'inline-block';
                logoTransparent.style.display = 'none';
            } else {
                logoMain.style.display = 'none';
                logoTransparent.style.display = 'inline-block';
            }
        };

        // Set initial state on load
        toggleLogoOnScroll();

        // Add scroll event listener to toggle logo based on scroll position
        window.addEventListener('scroll', toggleLogoOnScroll);

        // Set up event listeners for menu interaction (same as your original code)
        if (menuContainer && hamburger) {
            menuContainer.addEventListener('mouseover', (event) => {
                if (event.target.closest('.menu-lv-item.has-megamenu')) {
                    hamburger.classList.add('megamenuactive');
                    logoMain.style.display = 'inline-block';
                    logoTransparent.style.display = 'none';
                }
            });

            menuContainer.addEventListener('mouseout', (event) => {
                if (event.target.closest('.menu-lv-item.has-megamenu')) {
                    hamburger.classList.remove('megamenuactive');
                    logoMain.style.display = 'none';
                    logoTransparent.style.display = 'inline-block';
                }
            });
        }
    }

});


const element = document.querySelector('.accelerated-checkout-button');
const shadowRoot = element.shadowRoot; // Chỉ hoạt động nếu shadow DOM không đóng (open)

// Nếu shadowRoot là null thì DOM đang ở trạng thái closed
if (shadowRoot) {
  const target = shadowRoot.querySelector('.accelerated-checkout-button');
  if (target) {
    target.style.color = 'red'; // Áp dụng thay đổi style
  }
}



  